import {css} from "@emotion/react";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons";

interface IProps {
    left?: boolean;
    onClick?: () => void;
    className?: string;
    color?: string;
}

export const TableScrollButton = (props: IProps) => {
    const {onClick, left, color} = props;
    const resolvedColor = color ?? "var(--colors-primary)";

    return (
        <div css={scrollButton} onClick={onClick} className={props.className}>
            {left ? (
                <ChevronLeftIcon size="1.4" wrapperSize="3.2" wrapperColor={resolvedColor} onClick={onClick} />
            ) : (
                <ChevronRightIcon size="1.4" wrapperSize="3.2" wrapperColor={resolvedColor} onClick={onClick} />
            )}
        </div>
    );
};

const scrollButton = () => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @media print {
        display: none;
    }
`;
import {css} from "@emotion/react";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons";

interface IProps {
    left?: boolean;
    onClick?: () => void;
    className?: string;
    color?: string;
}

export const TableScrollButton = (props: IProps) => {
    const {onClick, left, color} = props;
    const resolvedColor = color ?? "var(--colors-primary)";

    return (
        <div css={scrollButton} onClick={onClick} className={props.className}>
            {left ? (
                <ChevronLeftIcon size="1.4" wrapperSize="3.2" wrapperColor={resolvedColor} onClick={onClick} />
            ) : (
                <ChevronRightIcon size="1.4" wrapperSize="3.2" wrapperColor={resolvedColor} onClick={onClick} />
            )}
        </div>
    );
};

const scrollButton = () => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @media print {
        display: none;
    }
`;
